package features.timeoff.domain

/**
 * Time off request domain model
 * @param id Firestore document ID
 * @param userId User who requested time off
 * @param startDate Start date in YYYY-MM-DD format
 * @param endDate End date in YYYY-MM-DD format
 * @param days Number of days (calculated)
 * @param type Leave category/type (e.g., "Annual Leave", "Sick Leave")
 * @param reason Reason for time off request
 * @param status Status: "Pending", "Approved", or "Rejected"
 * @param createdAt Timestamp when request was created
 * @param reviewedAt Timestamp when request was reviewed (approved/rejected)
 * @param reviewedBy User ID of admin/owner who reviewed the request
 */
data class TimeOffRequest(
    val id: String,
    val userId: String,
    val startDate: String,
    val endDate: String,
    val days: Int,
    val type: String,
    val reason: String,
    val status: String,
    val createdAt: String,
    val reviewedAt: String? = null,
    val reviewedBy: String? = null
)

data class LeaveType(
    val id: String,
    val name: String,
    val quota: Int,
    val default: Boolean = false
)

data class LeaveCategory(
    val id: String,
    val typeId: String,
    val name: String,
    val quota: Int,
    val deductible: Boolean = true,
    val documentationRequired: Boolean = false,
    val cutSalary: Boolean = false,
    val color: String = "slate"
)
